<template>
  <div class="user-details-item">
    <div class="user-details-title" @click="jumpDeatils">
      <div class="t">预警名称：{{item.warningName}}</div>
      <div
        class="one"
        :style="{'color':item.warningLevel==1?'#F8D541':item.warningLevel==2?'#F8D541':'#ED3939'}"
      >{{item.warningLevel}}级预警</div>
    </div>
    <div class="user-details-info" @click="jumpDeatils">
      <p>预警时间：{{item.warningTime}}</p>
      <p class="b">超时时间：<span style="color:#F8A651;">{{item.morethanTime}}</span></p>
      <p class="c" v-show="item.lastTime">距离升级{{item.nextLevelWarning}}时间：<span style="color:#ED3939;">{{item.lastTime}}</span></p>
    </div>
    <div class="user-details-footer">
      <van-button v-show="item.businessType == 1" style="margin-right: 10px; color:#666666;" round @click="jumpsubOrderDeatils">订单详情</van-button>
      <van-button v-show="item.businessType == 2" style="margin-right: 10px; color:#666666;" round @click="jumpAfterDeatils">售后详情</van-button>
      <van-button v-show="item.warningStatus==1 || item.warningStatus==2" :color="$theme.main_color_btn_bg" :style="{color:$theme.main_color_btn_title}" round @click="clickJumpFun">立即处理</van-button>
    </div>
    <modalItem :show="show" @closeModalFun="closeModalFun" :warningDeatils="item" :jumpDetals="item.jump"/>
  </div>
</template>
<script>
import modalItem from "./modalItem";
import utils from "@/utils/common";
export default {
  data() {
    return {
      show: false,
    };
  },
  props: {
    item: {
      default: function () {
        return {};
      },
      type: Object,
    },
  },
  methods: {
    showModal() {
      this.show = !this.show;
    },
    clickJumpFun() {
      this.showModal();
      // if (this.item.jump) {
       
      //   if(this.item.businessType ==1){
      //     this.jumpsubOrderDeatils();
      //   }else if(this.item.businessType ==2){
      //     this.jumpAfterDeatils();
      //   }else if(this.item.businessType ==3){
      //     this.$toast('Im');
      //   } 
      // } else {
      //   this.showModal();
      // }
    },
    closeModalFun(item) {
      if (item) {
        this.$emit("closeModal", true);
      }
      this.showModal();
    },
    // 工单详情
    jumpDeatils() {
      this.$router.push({
        path: "/warningmanagedetails",
        query: {
          id: this.item.id,
          warningStatus: this.item.warningStatus,
        },
      });
    },
    // 售后详情
    jumpAfterDeatils() {
      if (this.item.businessId) {
        utils.jumpToNewPage({
          url:
            window.location.origin +
            "/h5user/beeafterorderDetail?afterId=" +
            this.item.businessId,
          noTitle: "0",
        });
      }else{
        this.$toast('没有业务ID，暂无法查看售后详情')
      }
    },
    // 订单详情
    jumpsubOrderDeatils() {
      if (this.item.businessId) {
        utils.jumpToNewPage({
          url:
            window.location.origin +
            "/h5user/beesOrderDetail?subId=" +
            this.item.businessId,
          noTitle: "0",
        });
      }else{
        this.$toast('没有业务ID，暂无法查看订单详情')
      }
    },
  },
  components: { modalItem },
};
</script>
<style lang="less" scoped>
.user-details-item {
  background-color: #fff;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 20px;
  padding: 0 30px;
  border-radius: 10px;
  .user-details-title {
    border-bottom: 2px solid #f2f2f2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    height: 79px;
    color: #333;
    font-weight: 500;
    .one {
      color: #f8d541;
      font-size: 26px;
    }
    .two {
      color: #f8a651;
      font-size: 26px;
    }
    .three {
      color: #ed3939;
      font-size: 26px;
    }
  }
  .user-details-info {
    padding: 20px 0;
    color: #999;
    font-size: 24px;
    p {
      padding-top: 10px;
    }
    .b {
      b {
        color: #f8a651;
      }
    }
    .c {
      b {
        color: #ed3939;
      }
    }
  }
  .user-details-footer {
    text-align: right;
    .van-button {
      height: 64px;
      margin-bottom: 20px;
    }
  }
}
</style>